import { fileSelectionToggled } from '../../redux/slices/downloadCenterSlice';
import { useMemo } from 'react';

// This hook manages the selection of files in the download center. 
// It computes the list of selected files based on the current visible files 
// and the selected file names from the Redux state. 
// It also provides a handler to toggle the selection of a file when the user clicks on it.

const useDownloadCenterSelection = ({ dispatch, selectedFileNames, visibleFiles }) => {

  const selectedFiles = useMemo(
    () => visibleFiles.filter((file) => selectedFileNames[file.fileName]),
    [selectedFileNames, visibleFiles]
  );

  const handleFileSelect = (fileName) => {
    dispatch(fileSelectionToggled(fileName));
  };

  return { handleFileSelect, selectedCount: selectedFiles.length, selectedFiles, };
};

export default useDownloadCenterSelection;
